module.exports = __webpack_public_path__ + "static/media/menuMoreBlue.85838e63.svg";